const word = "_35swyne41e";

export { word };
import "./input.word.style.linaria.module.css";
//# sourceMappingURL=input.word.style.js.map
